import Lucene from 'services/lucene';

export default class LabelDetailsController {
    /** @ngInject */
    constructor(EventEmitter, DialogService) {
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
    }

    $onInit() {
        this.labelName = this.label.name;
        this.searchQuery = Lucene.convertLabelsToLuceneCompatible([{ id: this.label.id }]);
    }

    save() {
        this.onSaved(
            this.eventEmitter({
                label: this.label
            })
        );
        this.labelName = this.label.name;
    }

    cancel() {
        this.onEditCancelled();
    }

    validateLabel() {
        const validationErrors = this.onNameChange(
            this.eventEmitter({
                label: this.label
            })
        );

        if (validationErrors) {
            Object.keys(validationErrors).forEach((ruleName) => {
                this.labelForm.name.$setValidity(ruleName, validationErrors[ruleName]);
            });
        }
    }

    showDeleteConfirmation() {
        this.DialogService.confirm({
            title: 'Delete Label?',
            textContent: `Do you really want to delete label "${this.labelName}"?`,
            ariaLabel: 'delete-label',
            ok: 'Delete',
            cancel: 'Cancel'
        }).then(() => {
            this.onDeleted(
                this.eventEmitter({
                    label: this.label
                })
            );
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/label-details/label-details.controller.js